import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-info">
                    <h3 className="nav-logo">THE<span>IC</span></h3>
                    <p>Expert VLSI Physical Design & DFT Training Institute. Empowering the next generation of semiconductor professionals.</p>
                </div>
                <div className="footer-links">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/courses/physical-design">Courses</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <div className="footer-contact">
                    <h4>Get In Touch</h4>
                    <p>Email: <a href="mailto:theictheic90@gmail.com">theictheic90@gmail.com</a></p>
                    <p>Phone: <a href="tel:+919398580968">+91 9398580968</a></p>
                    <p>Location: Bangalore/Hyderabad, India</p>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} THEIC. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
